import { useMutation } from '@tanstack/react-query';

import { fetchAcceptIdpDisclaimer } from '../api/acceptIdpDisclaimer.js';

export function useAcceptIdpDisclaimerMutation() {
  return useMutation({
    mutationKey: ['dosespot-idp', 'accept-disclaimer'],
    mutationFn: async () => {
      return await fetchAcceptIdpDisclaimer();
    },
  });
}
